import * as Yup from 'yup';
import '@dfl/yup-validations';

export const rejectBusinessAccountRequestSchema = Yup.object().shape({
  rejectionReason: Yup.string().trim().required('required').min(3, 'min-3').max(500, 'max-500'),
});

export const initRejectBusinessAccountRequestValues = {
  rejectionReason: '',
};

export const businessAccountRequestCompanySchema = Yup.object().shape({
  businessType: Yup.string().nullable(),
  commercialName: Yup.string().trim().required('required').max(255, 'max-255'),
  taxId: Yup.string().trim().max(64, 'max-64'),
  sector: Yup.string(),
  country: Yup.string().trim().max(255, 'max-255'),
  taxAddress: Yup.string().trim().max(255, 'max-255'),
  // @ts-ignore
  phone: Yup.string().phone('validPhone').nullable(),
});

export const businessAccountRequestRepresentativeSchema = Yup.object().shape({
  name: Yup.string().trim().required('required').max(255, 'max-255'),
  role: Yup.string().trim().max(255, 'max-255'),
  // @ts-ignore
  phone: Yup.string().phone('validPhone').nullable(),
  idDocumentNumber: Yup.string().trim().max(64, 'max-64'),
});
